/* System defined core library */
import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { RoutingService } from '../../../shared/services/routing.service';
import { UtilityService } from '../../../shared/services/utility.service';
import { MetricApiService } from '../../shared/services/metric-api.service';
import { SelectedExamDetailService } from '../../shared/services/selected-exam-detail.service';

/* User defined models */
import { Candidate } from '../../../shared/models/scheduling/candidate.model';
import { Client } from '../../../shared/models/scheduling/client.model';
import { Program } from '../../../shared/models/scheduling/program.model';

/* User defined enums/constants */
import { ComponentType, LogLevel } from '../../../shared/enums/scheduling.enum';
import { DynamicFormBase } from '../../../shared/models/common/dynamic-form-base.model';


@Component({
  selector: 'app-candidate-profile',
  templateUrl: './candidate-profile.component.html'
})
export class CandidateProfileComponent {

  // reset data on going back
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    if (!this.utilityService.isNullOrUndefined(this.candidate)) {
      if (this.candidate.defaultInitialDetails != null && this.candidate.defaultInitialDetails != undefined) {
        this.candidate.defaultDetails = this.candidate.defaultInitialDetails;
      }
      else {
        this.candidate = null;
      }
    }
    this.selectedExamDetailService.SetCandidateDataSource(this.candidate);

    this.dynamicInputCtrls.forEach(dynamicInputCtrl => {
      if (dynamicInputCtrl.controlType === 'datepicker') {
        dynamicInputCtrl['rawDate'] = undefined;
      }
      if (!!dynamicInputCtrl['selectedOption']) {
        dynamicInputCtrl['selectedOption'] = undefined;
      }
    });

    this.metricApiService.log(LogLevel.Info, 'Navigating Backwards from Candidate Profile page.');
  }

  /* User defined private/public variables  */
  public isDynamicFrmValid: Boolean;
  public isFormLoaded: Boolean;
  public candidate: Candidate;
  public dynamicInputCtrls: DynamicFormBase<any>[];
  public client: Client;
  public program: Program;

  /* Service subscriptions */
  candidate$: Subscription;
  dynamicInputCtrls$: Subscription;
  translateLanguage$: Subscription;
  client$: Subscription;
  program$: Subscription;


  /* Constructor declaration with required injected services */
  constructor(
    private _location: Location,
    private cdr: ChangeDetectorRef,
    private metricApiService: MetricApiService,
    private routingService: RoutingService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {
    this.candidate$ = selectedExamDetailService.candidate.subscribe(
      candidate => {
        this.candidate = candidate;
      });

    this.client$ = selectedExamDetailService.client.subscribe(
      client => {
        this.client = client;
      });

    this.dynamicInputCtrls$ = selectedExamDetailService.formInputData.subscribe(
      formInputData => {
        this.dynamicInputCtrls = formInputData;
      });

    this.program$ = selectedExamDetailService.program.subscribe(
      program => {
        this.program = program;
      });

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.CandidateProfileComponent)) return;
  }

  /* Move to next screen  */
  proccedTocheckOut(): void {
    this.candidate.defaultInitialDetails = this.candidate.defaultDetails;
    this.candidate.defaultDetails = null;
    this.selectedExamDetailService.SetCandidateDataSource(this.candidate);
    this.routingService.scheduleFwdNavigation(ComponentType.CandidateProfileComponent);
  }

  /* Move back to previous page*/
  goToPrevPage(): void {
    this._location.back();
    if (this.candidate && this.candidate.details) {
      this.candidate.details = null;
    }

    if ((this.candidate && this.candidate.defaultInitialDetails) && (this.candidate && !this.candidate.defaultDetails)) {
      this.candidate.defaultDetails = this.candidate.defaultInitialDetails;
    }
    this.selectedExamDetailService.SetCandidateDataSource(this.candidate);
  }

  /* check next button disable */
  isDisable(): boolean {
    return !this.isDynamicFrmValid;
  }


  /* Check whether candidate form is valid or not */
  setDynamicFormvalid(isDynamicFrmValid: boolean): void {
    this.isDynamicFrmValid = isDynamicFrmValid;
    this.cdr.detectChanges();
  }

  /* Show the navigation button if valid */
  setFormLoadedFlag(event: any): void {
    this.isFormLoaded = event;
  }
}
